const closeButtonLabel = "Luk";
const daDK = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  daDK as default
};
